import React from "react";
import "./Migracion.css";
import TarjetaDeServicioMigracion from "./components/TarjetaDeServicioMigracion";
import GestionProyecto from "../services/components/GestionProyecto";
import { useTranslation } from "react-i18next";

interface ServiceItem {
  title: string;
  desc: string;
}

export default function Migracion() {
  const { t } = useTranslation();

  const services: ServiceItem[] = [
    {
      title: t("pages.migracion.services.0.title"),
      desc: t("pages.migracion.services.0.desc"),
    },
    {
      title: t("pages.migracion.services.1.title"),
      desc: t("pages.migracion.services.1.desc"),
    },
    {
      title: t("pages.migracion.services.2.title"),
      desc: t("pages.migracion.services.2.desc"),
    },
  ];

  const gestionArr = t("pages.migracion.gestion", { returnObjects: true }) as any[];
  const alcanceArr = t("pages.migracion.alcance", { returnObjects: true }) as any[];

  return (
    <div className="pagina-migracion">
      <div
        className="migracion-page-background"
        style={{
          backgroundImage: 'url("/ImgMigraciones.webp")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "relative",
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          paddingLeft: "clamp(1rem, 2vw, 2rem)",
        } as React.CSSProperties}
      >
        <div className="migracion-page-overlay">
          <h1>{t("pages.migracion.title")}</h1>
          <p className="migracion-texto-largo">{t("pages.migracion.description")}</p>
        </div>
      </div>
      <h2
        style={{
          textAlign: "center",
          marginTop: "50px",
          fontSize: "clamp(1.5rem, 5vw, 36px)",
        } as React.CSSProperties}
      >
        {t("pages.migracion.benefits_title")}
      </h2>
      <div className="card-grid">
        {services.map((s, i) => {
          let animationClass = "";
          if (i === 0) animationClass = "from-left";
          else if (i === 1) animationClass = "from-bottom";
          else if (i === 2) animationClass = "from-right";
          return (
            <TarjetaDeServicioMigracion
              key={s.title}
              service={s}
              animationClass={animationClass}
              delay={0}
            />
          );
        })}
      </div>
      <GestionProyecto gestion={gestionArr} alcance={alcanceArr} />
    </div>
  );
}
